
const COMMON_API = {

    /**  User Master  */
    USER_LIST: 'api/users/getUserList',
    USER_SAVE: 'api/users/setUser',
    USER_DELETE: 'api/users/deleteUser',
    USER_UPDATE: 'api/users/UpdateUser',
    USER_ROLE_LIST: 'api/userrole/getUserRoleList',
    USER_EDIT: 'api/users/getUserDetails',

    RESET_PASWORD: 'api/users/resetPassword',
    CHANGE_PASWORD: 'api/users/setChangePassword',

    ERROR_LOG_INFO: 'api/error/errorLogInfo',
    LOGIN: 'api/login/login',

    REFRESHTOKEN: 'api/login/refreshToken',

    /**Master Data */
    GET_MASTER_DATA:'api/common/getMasterList',

    /**Sales Rep Master */
    GET_SALES_REP_LIST:'api/salesrep/getSalesRepList',
    ADD_SALES_REP:'api/salesrep/saveSalesRep',
    UPDATE_SALES_REP:'api/salesrep/updateSalesRep',
    SALES_REP_DELETE:'api/salesrep/deleteSalesRep',
    SALES_REP_RESET_PASSWORD:'api/salesrep/resetPin',

    /** Party Master */
    GET_PARTY_LIST:'api/party/getPartyList',
    ADD_PARTY_MASTER:'api/party/saveParty',
    UPATE_PARTY:'api/party/updateParty',
    PARTY_DELETE:'api/party/deleteParty',

    /**Visit History */
    GET_VISIT_HISTORY:'api/visitorHistory/getVisitorHistory',

    /** Dashboard */
    GET_DASHBOARD:'api/dashboard/getDashboard',

};

export default COMMON_API;